import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("input", {
        onChange: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => ($options.onChangeInput && $options.onChangeInput(...args))),
        type: "file",
        name: "image",
        accept: "image/*",
        capture: "environment",
        multiple: ""
    }, null, 32));
}
